import { ReactNode, CSSProperties, MutableRefObject, Key, } from "react";
import { columnsProps, TableActionType, } from "../SuperTable/interface";
import { PaginationProps } from "antd/lib/pagination";

export interface DropdownTableProps extends SelectDropdownBaseProps, SelectInputBaseProps {
  /** 样式 */
  style?: CSSProperties,
  /** 类名 */
  className?: string;
  /** 对外方法 */
  actionRef?: MutableRefObject<SuperSelectActionType>;
  /** 下拉框大小 */
  size?: SizeType;
  /** 支持清除 */
  allowClear?: boolean;
  /** 是否默认展开下拉菜单 */
  defaultOpen?: boolean;
  /** 指定默认选中的条目 */
  defaultValue?: DropdownTableValue;
  /** 是否展开下拉菜单 */
  open?: boolean;
  /** 禁用时超出字符串是否省略 */
  isDisabledEllipsis?: boolean;
  /** 禁用时是否显示虚线的下边框 */
  disabledBorderDashed?: boolean;
  /** 禁用是显示内容 */
  disabledRender?: ReactNode | ((data?: any) => ReactNode);
  /** 失去焦点时回调 */
  onBlur?: () => void;
  /** 获得焦点时回调 */
  onFocus?: () => void;
  /** 选中 option，或 input 的 value 变化时，调用此函数 */
  onChange?: (value?: DropdownTableValue, options?: DropdownTableOption | DropdownTableOption[]) => void;
  /** 被选中时调用，参数为选中项的 value (或 key) 值 */ 
  onSelect?: (value?: DropdownTableValue, options?: DropdownTableOption | DropdownTableOption[]) => void;
}

export interface SelectInputBaseProps {
  /** value为空是提示文字 */
  placeholder?: string;
  /** 是否在加载中状态 */
  loading?: boolean;
  /** 支持清除 */
  allowClear?: boolean;
  /** 是否禁用 */
  disabled?: boolean;
  /** 清除内容时回调 */
  onClear?: () => void;
}

export interface SelectDropdownBaseProps {
  /** 值 */
  value?: DropdownTableValue;
  /** 是否在加载中状态 */
  loading?: boolean;
  /** 模式 */
  mode?: modeType;
  /** 选项是否可以进行搜索 */
  showSearch?: boolean;
  /** 选项 */
  options?: DropdownTableOption[];
  /** 表格列配置 */
  columns?: columnsProps[];
  /** 下拉菜单的 className 属性 */
  popupClassName?: string;
  /** 下拉菜单的 style 属性 */
  dropdownStyle?: CSSProperties;
  /** 下拉菜单和选择器同宽。默认将设置 min-width，当值小于选择框宽度时会被忽略 */
  dropdownMatchSelectWidth?: number;
  /** 设置弹窗滚动高度 */
  listHeight?: number;
  /** Dropdown宽度 */
  dropdownWidth?: number;
  /** 自定义下拉框底部内容 */
  dropdownFooterRender?: ReactNode;
  /** 自定义节点 label、subLabel、value、 defauleSelected 的字段 */
  fieldNames?: FieldNamesType;
  /** 是否为本地搜索 */
  isLocalSearch?: boolean;
  /** 搜索框提示 */
  searchPlaceholder?: string;
  /** 本地搜索时是否区分大小写 */
  searchDiscriminateCase?: boolean;
  /** 分页配置 */
  pagination?: false | PaginationProps;
  /** 自动分页 */
  autoPage?: boolean;
  /** 是否将字母自动转换成大写 */
  isUpperCase?: boolean;
  /** 列表对象 */
  tableRef?: MutableRefObject<TableActionType>;
  /** 自定义Option选项 */
  renderOption?: (record: any) => ReactNode;
  /** 菜单渲染父节点。默认渲染到 body 上 */
  getPopupContainer?: () => HTMLElement | HTMLElement;
  /** 文本框搜索值变化时回调 */
  onSearch?: (searchValue?: string) => void;
  /** 列表分页切换 */
  onPaginationChange?: (pageParams: any) => void;
}

export interface DropdownOffset {
  /** 距离页面左部的距离 */
  left: number;
  /** 距离页面头部的距离 */
  top: number;
  /** 距离页面底部的距离 */
  bottom?: number;
}

export interface DropdownTableOption {
  /** 行标识 */
  key?: Key;
  /** 其他 */
  [prop: string]: any;
}
export type FieldNamesType = Partial<IfieldNames>;
export interface IfieldNames {
  /** 标题 */
  label: string;
  /** 值 */
  value: string;
}
export type DropdownTableValue = Key | Key[];
export type SizeType = 'small' | 'middle' | 'large';
export type modeType = 'multiple' | 'tags';
/** fieldNames默认值 */
export const DEFAULT_FIELD_NAMES: IfieldNames = {
  label: 'label',
  value: 'value',
};
interface SuperSelectAction {
  /** 获取焦点 */
  focus: () => void;
  /** 失去焦点 */
  blur: () => void;
  /** 清空搜索值 */
  emptySearch: () => void;
  /** 获取所有选项 */
  getOption: () => DropdownTableOption[];
};
export type SuperSelectActionType = SuperSelectAction | undefined;

interface SelectDropdownAction {
  /** 清空搜索值 */
  onEmptySearch: () => void;
}
export type SelectDropdownActionType = SelectDropdownAction | undefined;
